module.exports = "/_next/static/images/45e1eac119af188435f3a556f6036957-features-xs.jpg";